import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTOWorkspaceTranserOwnershipProposal extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_TRANSFER_OWNERSHIP_PROPOSAL;

  //STATIC METHODS

  /*
   * DB FIELDS
   */
  workspace_id!: string;
  target_user_id!: string;

  /*
   * RUNTIME FIELDS
   */
  target_full_name!: string;
  target_avatar_url_relative!: string;

  workspace_name!: string;
  workspace_avatar_url_relative!: string;

  owner_user_id!: string;
  owner_full_name!: string;
  owner_avatar_url_relative!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.workspace_id);
    assert_string_not_empty(this.target_user_id);

    assert_string_not_empty(this.target_full_name);

    assert_string_not_empty(this.workspace_name);

    assert_string_not_empty(this.owner_user_id);
    assert_string_not_empty(this.owner_full_name);
  }
}
